import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  InvestmentTypeEnum,
  SymbolV2,
  Symbol,
  useGetQuotesV2,
} from "@bn/api/apiv1";
import { SecuritiesSearch } from "@components/SecuritySearch/SecuritiesSearch";
import { StepContainer } from "../StepContainer";
import { NoQuoteModal } from "../NoQuoteModal";

export interface Props {
  handleNext: (symbol: Symbol | SymbolWithQuote) => void;
  handlePrevious?: () => void;
  type?: InvestmentTypeEnum;
  depotId?: number;
}

export const SearchSymbolStep = ({
  handlePrevious,
  handleNext,
  type,
  depotId,
}: Props) => {
  const { t } = useTranslation();
  const [showNoQuoteModal, setShowNoQuoteModal] = useState(false);
  const [securityToAdd, setSecurityToAdd] = useState<SymbolV2>();

  const { data: quotes, isFetching } = useGetQuotesV2(
    {
      securityId: [securityToAdd?.id!],
      quoteProvider: securityToAdd?.quoteProvider!,
    },
    {
      enabled: Boolean(securityToAdd),
      onSuccess: (data) => {
        const quote = data.quotes?.[0];
        if (quote) {
          handleNext({
            ...securityToAdd,
            quote: quote,
          });
        } else {
          setShowNoQuoteModal(true);
        }
      },
    }
  );

  const handleSymbolSelect = (symbol: SymbolV2) => {
    if (
      symbol.name === securityToAdd?.name &&
      !quotes?.quotes?.length &&
      !isFetching
    ) {
      setShowNoQuoteModal(true);
      return;
    }
    setSecurityToAdd(symbol);
  };

  return (
    <StepContainer
      testid="search-symbol-step"
      title={t("transactionWizard.searchSymbolsStep.title")}
      onPrevious={handlePrevious}
    >
      <SecuritiesSearch
        onSymbolSelect={handleSymbolSelect}
        defaultSearchFilter={type}
        showManual
        depotId={depotId}
      />
      <NoQuoteModal
        open={showNoQuoteModal}
        onClose={() => setShowNoQuoteModal(false)}
        type={securityToAdd?.type ?? ""}
      />
    </StepContainer>
  );
};
